import React from 'react';
import unauthorized from "../../assets/images/unauthorized.svg";
import { Button,Typography } from '@mui/material';
import { Link } from 'react-router-dom';

 const UnauthorizedPage = () => {
  return (
    <div className="content" style={{ textAlign: "center" }}>
     
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={unauthorized}
          alt="Page Not Found"
          style={{
            width: "100%",
            maxWidth: "550px",
            height: "500px",
            marginBottom:"10px"
          }}
        />
      </div>
      <Typography
        variant="h4"
        sx={{fontWeight:"bold"}}
      >
        sorry! You're Not authorized to access the page 
      </Typography>

      
      <Link to="/">
    
      <Button
        variant="text"
        sx={{
          textTransform: "none",
          fontSize: "16px",
        }}
      >
        Back to Home Page
      </Button>
      </Link>
    </div>
  );
};
 export default UnauthorizedPage;